<template>
  <div class="info-page">
    <!-- 仅原来的 section 3 内容 -->
    <div v-wechat-title="'最强蜗牛'"></div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName" :game_id="39" :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false" @loginSuccess="loginSuccess" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell' @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' :downloadApp="downloadApp" />
    <div class="content-box">
      <div class="btn-box">
        <div class="btn taptap-btn" @click="goLink('https://l.taptap.cn/ovT12vw0?channel=rep-rep_uvbcbbs5do5', '五周年庆_点击taptap按钮')" />
        <div class="btn hykb-btn" @click="goLink('https://m.3839.com/a/117233.htm', '五周年庆_点击好游快爆按钮')" />
      </div>
      <div class="banner-box" />
      <div class="activities-box">
        <div class="activities-content">
          <div class="tabs-container" ref="tabsContainer">
            <div v-for="(tab, index) in activitiesCards" ref="tabItems" :key="index" :class="`tab-item tab-item-${index+1} ${activeIndex === index ? 'active' : ''}`" @click="goToSlide(index)" />
          </div>
          <div class="activities-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in activitiesCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="btn-go" @click="enterUrl" :class="{ disabled: isNotStarted(activitiesCards.find((i,index) => index === activeIndex).time) }" />
          <div class="activities-swiper-button-next swiper-button-next"></div>
          <div class="activities-swiper-button-prev swiper-button-prev"></div>
          <!-- <div class="activities-swiper-pagination swiper-pagination"></div> -->
        </div>
        <div class="bosi-left"></div>
        <div class="bosi-right"></div>
      </div>
      <div class="video-box">
        <div :class="`video-content video-content-${currentUperIndex + 1}`">
          <div class="player" @click="openPopup" />
        </div>
        <div class="role-box">
          <div v-for="(card, index) in uperCards" :class="`role-item uper-${index+1} ${currentUperIndex === index ? 'active' : ''}`" :key="card.id" @click="chooseUper(card.name, index)" />
        </div>
        <div :class="`people-box people-box-${currentUperIndex + 1}`" />
        <div class="yunduo" />
      </div>
      <div class="game-feature-box">
        <div class="game-feature-content">
          <div class="game-feature-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in gameFeatureCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="game-feature-swiper-button-next swiper-button-next"></div>
          <div class="game-feature-swiper-button-prev swiper-button-prev"></div>
          <div class="game-feature-swiper-pagination swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 视频弹窗 -->
    <div class="video_wrap popup_wrap" v-show="videoShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active" :duration="{ enter: 1000 }">
        <div class="detail_box">
          <video v-if="videoShow" autoplay="autoplay" controlslist="nodownload" disablepictureinpicture="true" controls :src="pvUrl"></video>
          <div class="close_btn" @click="closePopup" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Header from '../Header/index.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast, Indicator } from 'mint-ui'
import { headerConfig } from '../headerConfig'
import Os from '@/components/os'
import Login from '@/components/login'
import { getTimeStamp, buriedLogger } from "@/utils/utils"
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { onGetTimeAPI } from '../api';

export default {
  name: 'RecallInfo',
  components: {
    Header,
    swiper,
    swiperSlide,
    Login,
    Os,
  },
  props: ['downloadApp'],
  data() {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      loginTypes: ["sms", "password"],
      activitiesSwiper: null,
      gameFeatureSwiper: null,
     activitiesCards: [
  {
    label: '周年大促销',
    id: 1,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity1.png',
    url: 'https://pay.qingcigame.com/pay?gameId=39',
    time: '2025-06-20 05:00:00'
  },
  {
    label: '限定纪念奖章',
    id: 2,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity2.png',
    url: 'https://snail.qingcigame.com/adver/68/9.html',
    time: '2025-06-18 05:00:00'
  },
  {
    label: '五周年法庭',
    id: 3,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity3.png',
    url: 'https://snail.qingcigame.com/adver/69/14.html',
    time: '2025-06-17 08:00:00'
  },
  {
    label: '积分商城',
    id: 4,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity4.png',
    url: 'https://pay.qingcigame.com/pointsmall',
    time: '2025-06-19 12:00:00'
  },
  {
    label: '官方歪挂',
    id: 5,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity5.png',
    url: 'https://mp.weixin.qq.com/s/3VnAjfbpjWdExg3JDrkf3A',
    time: '2025-06-23 12:00:00'
  },
  {
    label: '盖楼送祝福',
    id: 6,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity6.png',
    url: 'https://l.taptap.cn/n49pp3e6?channel=rep-rep_1al0nwjwv04',
    time: '2025-06-15 12:00:00'
  },
  {
    label: '签到领奖励',
    id: 7,
    image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/bg_activity7.png',
    url: 'https://l.taptap.cn/lF1NCyGX?channel=rep-rep_0vef2prtpx7_h5url4251',
    time: '2025-06-20 08:00:00'
  }
],

gameFeatureCards: [
  { id: 1, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game1.png' },
  { id: 2, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game2.png' },
  { id: 3, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game3.png' },
  { id: 4, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game4.png' },
  { id: 5, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game5.png' },
  { id: 6, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game6.png' },
  { id: 7, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game7.png' },
  { id: 8, image: 'https://download4.qcplay.com/h5-images/active/snail/recall/3/game8.png' }
],
      activeIndex: 0,
      videoShow: false,
      pvUrl: '',
      logger: null,
      currentUperIndex: 0,
      uperCards: [
        { id: 1, name: '小芃', videoUrl: 'https://download4.qcplay.com/qcgame-admin/IrqyiXnj8CcOZ4aIDhdRqMXec9rvYwbjFcHy65HD.mp4' },
        { id: 2, name: '薪儿姐', videoUrl: 'https://download4.qcplay.com/qcgame-admin/9vAH6w2qhsboyBBM1dQNB7cBG1wcmH9o5Q5LDEc6.mp4' },
        // { id: 3, name: '三金啊', videoUrl: '' },
      ],
      currentTime: '',
    }
  },
  created() {
    const bl = buriedLogger('snail', '最强蜗牛_资讯页')
    this.logger = bl
    onGetTimeAPI().then((res) => {
      if (res.code !== 200) {
        return
      }
      this.currentTime = res.data.time
    })
  },
  mounted() {
    this.initSwiper()
    this.initSwiperGameFeature()
    this.setShare({
      link: `https://h5.qingcigame.com/snail/recall/anniversary${getTimeStamp()}`,
      title: '《最强蜗牛》五周年版本上线',
      imgUrl: 'https://download4.qcplay.com/qcgame-api/sTsPyCJ08V30Y19cL9SoXTH5RFXqt6eaC3v60hP6.png',
      desc: '什么！百抽都成基础福利了？'
    })
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  methods: {
    chooseUper(name, index) {
      if (this.currentUperIndex === index) return
      this.currentUperIndex = index
    },
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    isNotStarted(time) {
      const currentTime = this.currentTime ? new Date(this.currentTime.replace(/-/g, "/")) : new Date()
      return new Date(time.replace(/-/g, "/")) > currentTime; // 如果活动时间在当前时间之后
    },
    initSwiper() {
      this.activitiesSwiper = new Swiper('.activities-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.activities-swiper-pagination',
        paginationClickable: true,
        nextButton: '.activities-swiper-button-next',
        prevButton: '.activities-swiper-button-prev',
        onSlideChangeStart: (swiper) => {
          this.activeIndex = swiper.realIndex
          this.scrollToCenter(swiper.realIndex)
        }
      })
      this.activeIndex = this.activitiesSwiper.realIndex
    },
    goToSlide(targetIndex) {
      const swiper = this.activitiesSwiper;
      const currentIndex = swiper.activeIndex; // 当前 DOM 索引
      const slides = Array.from(swiper.slides); // 克隆后的所有 slide

      // 获取所有匹配的 slide 索引
      const matchingIndexes = slides
        .map((slide, i) => ({
          index: i,
          realIndex: +slide.getAttribute('data-swiper-slide-index')
        }))
        .filter(slide => slide.realIndex === targetIndex)

      // 找到与当前 slide 最接近的目标 index
      const nearest = matchingIndexes.reduce((prev, curr) => {
        return Math.abs(curr.index - currentIndex) < Math.abs(prev.index - currentIndex)
          ? curr
          : prev;
      });

      if (nearest) {
        swiper.slideTo(nearest.index, 300);
        this.activeIndex = targetIndex;
        this.scrollToCenter(targetIndex)
      }
    },
    scrollToCenter(index) {
      const container = this.$refs.tabsContainer;
      const tabItems = this.$refs.tabItems;
      const tab = tabItems[index];

      // 计算滚动的中心位置
      const tabOffsetLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const containerWidth = container.offsetWidth;

      const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    },
    enterUrl() {
      const { label, url, time } = this.activitiesCards.find((i, index) => index === this.activeIndex) || {}
      if (this.isNotStarted(time)) return
      this.goLink(url, `五周年庆_${label}跳转`)
    },
    goLink(url, loggerName) {
      if (url === '') return
      Indicator.open();
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    initSwiperGameFeature() {
      this.gameFeatureSwiper = new Swiper('.game-feature-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.game-feature-swiper-pagination',
        paginationClickable: true,
        nextButton: '.game-feature-swiper-button-next',
        prevButton: '.game-feature-swiper-button-prev',
      })
    },
    openPopup() {
      const { name, videoUrl } = this.uperCards.find((i, index) => index === this.currentUperIndex) || {}
      this.pvUrl = videoUrl
      this.videoShow = true
      this.logger.sum(`五周年庆_${name}视频点击`)
    },
    closePopup() {
      this.videoShow = false
    },
    selectCallback() {
    },
    loginSuccess() {
      console.log('登录成功')
    },
    osCancell() {
      console.log('osCancell')
    },
    getSelectInfo() {
      console.log('getSelectInfo')
    },
    logoutCallback() {
      console.log('logoutCallback')
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
}
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/snail/recall/info/index.vue